<template>
  <div class="main-container">
    <div class="main-container-title-box">
      <div class="main-container-title-box-text" style="margin-left: 12px">
        <span> Голосование </span>
      </div>
      <v-btn
        @click="goToEdit"
        style="width: auto !important"
        class="button-action-blue"
      >
        Редактировать
      </v-btn>
    </div>

    <div
      class="d-flex align-center main-container-info-box"
      style="margin: 0 24px 40px 12px"
    >
      <v-switch
        v-model="settings.showElection"
        @change="showInApp"
        hide-details
        color="var(--app-green-1)"
      ></v-switch>
      <span>Отображать раздел</span>
    </div>

    <div class="main-container-info-box">
      <div>
        <div class="table-title">Изображение</div>
      </div>

      <div>
        <v-simple-table v-if="settings">
          <template v-slot:default>
            <thead>
              <tr>
                <th style="padding-left: 24px" class="text-left">Формат</th>
                <th class="text-left">Место отображенния</th>
                <th class="text-left">Для смартфонов</th>
                <th class="text-left">Для планшетов</th>
                <th class="text-left"></th>
              </tr>
            </thead>
            <tbody>
              <tr style="height: 60px">
                <td style="padding-left: 24px" class="text-left">
                  Иконка раздела
                </td>
                <td class="text-left">Изображение на фоне раздела</td>
                <td class="text-left">
                  <img
                    @click="openDialogImg(settings.iconMobile)"
                    v-if="settings.iconMobile"
                    class="table-img"
                    :src="settings.iconMobile"
                  />
                </td>
                <td class="text-left">
                  <img
                    @click="openDialogImg(settings.iconTablet)"
                    v-if="settings.iconTablet"
                    class="table-img"
                    :src="settings.iconTablet"
                  />
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>

        <DialogImage v-model="dialogImg" :src="previewImage" />
        <v-divider></v-divider>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data: () => ({
    showInfo: false,
    settings: {},
    dialogImg: false,
    previewImage: null,
    imageWidth: 0,
    showInfoImg: false,
    showElection: false,
  }),
  methods: {
    showInApp() {
      const sendObject = {
        showElection: this.settings.showElection,
        icon: this.settings.icon,
        iconMobile: this.settings.iconMobile,
        iconTablet: this.settings.iconTablet,
      };
      this.$axios
        .post(
          this.$store.getters.apiAdminPanelV5 +
            "/ksa-election-blocks/election-settings",
          sendObject,
          {
            headers: {
              authorization: this.$store.getters.adminPanelHeaderAuth,
              "secret-key": this.$store.state.secretKeyCookie,
            },
          }
        )
        .then(() => {
          this.$store.commit("errorSet", {
            key: true,
            type: "success",
            text: "Настройки сохранены",
          });
        })
        .catch((err) => {
          this.$store.commit("errorSet", true);
          this.$store.commit("errorTextSet", err);
        });
    },
    goToEdit() {
      this.$emit("goToEdit");
    },

    getElectionSettings() {
      this.$axios
        .get(
          this.$store.getters.apiAdminPanelV5 +
            "/ksa-election-blocks/election-settings",
          {
            headers: {
              authorization: this.$store.getters.adminPanelHeaderAuth,
              "secret-key": this.$store.state.secretKeyCookie,
            },
          }
        )
        .then((res) => {
          this.settings = res.data;
        })
        .catch((err) => {
          this.$store.commit("errorSet", true);
          this.$store.commit("errorTextSet", err);
        });
    },
  },
  created() {
    this.getElectionSettings();
  },
};
</script>
<style lang="scss" scoped>
.main-container {
  .main-container-title-box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 40px 24px 20px 24px;

    .main-container-title-box-text {
      display: flex;
      align-items: center;

      span {
        font-size: 28px;
        font-weight: 400;
        margin-right: 20px;
      }
    }
  }

  .main-container-info-box {
    padding: 0 24px;
    .table-title {
      font-size: 24px;
      font-weight: 600;
      margin: 0 24px;
    }

    .info-block {
      width: 50%;
      margin-bottom: 50px;

      .info-block-title {
        font-size: 24px;
        font-weight: 600;
      }

      .info-block-text {
        font-size: 18px;
        font-weight: 400;
      }
    }

    .table-img {
      cursor: pointer;
      height: 38px;
      object-fit: contain;
    }
  }
}

.table-title {
  font-size: 24px;
  font-weight: 600;
}
</style>
